import { render, staticRenderFns } from "./AlertNoData.vue?vue&type=template&id=47833e36&scoped=true"
import script from "./AlertNoData.vue?vue&type=script&lang=js"
export * from "./AlertNoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47833e36",
  null
  
)

export default component.exports